"use client";

import { useEffect, useState } from "react";
import { Link } from "@/components/common/Link";
const indexItems = [{
  label: "Rule Layer & Escalation",
  to: "#api-specifications"
}, {
  label: "Classification Pipeline",
  to: "#integration-guides"
}, {
  label: "Taxonomy",
  to: "#data-formats"
}, {
  label: "Architecture",
  to: "#system-architecture"
}];
const deepDiveItems = [{
  label: "Rule Layer",
  to: "/RuleLayerPage"
}, {
  label: "Model Escalation",
  to: "/ModelEscalationPage"
}, {
  label: "Fine-Tuning Roadmap",
  to: "/FineTuningRoadmapPage"
}, {
  label: "Classification Taxonomy",
  to: "/ClassificationTaxonomyPage"
}];
export default function SectionIndex() {
  const [activeHash, setActiveHash] = useState("");
  const [currentPath, setCurrentPath] = useState("");
  useEffect(() => {
    const handleHashChange = () => {
      setActiveHash(window.location.hash);
    };
    handleHashChange();
    window.addEventListener("hashchange", handleHashChange);
    return () => window.removeEventListener("hashchange", handleHashChange);
  }, []);
  useEffect(() => {
    if (typeof window !== "undefined") {
      setCurrentPath(window.location.pathname);
    }
  }, []);
  return <>
      {/* Horizontal bar: rendered only below lg */}
      <div className="lg:hidden">
        <section id="inpagesectionindex" data-nav="light" className="sticky top-16 z-40 w-full border-b border-border bg-background/95 backdrop-blur-md text-foreground transition-colors" aria-label="In-page section navigation">
          <div className="max-w-7xl mx-auto px-6 sm:px-12 py-2.5">
            <nav aria-label="Page sections">
              <ul className="flex items-center gap-6 sm:gap-8 overflow-x-auto whitespace-nowrap [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
                {indexItems.map((item, i) => {
                const isActive = activeHash === item.to;
                return <li key={item.to} data-index={i} className="shrink-0">
                      <Link to={item.to} className={`relative inline-flex items-center min-h-[44px] py-1 font-mono text-xs uppercase tracking-[0.2em] transition-colors duration-200 outline-none focus-visible:ring-2 focus-visible:ring-ring ${isActive ? "text-primary after:w-full" : "text-muted-foreground hover:text-primary"} after:absolute after:bottom-1 after:left-0 after:h-[2px] after:bg-primary after:transition-all after:duration-200 ${isActive ? "after:w-full" : "after:w-0 hover:after:w-full"}`}>
                        {item.label}
                      </Link>
                    </li>;
              })}
              </ul>
            </nav>
          </div>
        </section>
      </div>

      {/* Vertical sidebar: rendered at lg and above */}
      <aside className="hidden lg:flex lg:flex-col lg:sticky lg:top-[88px] lg:self-start lg:h-[calc(100vh-88px)] lg:w-64 lg:shrink-0 overflow-y-auto border-r border-border bg-background px-6 py-8 flex flex-col gap-10" aria-label="Documentation sidebar">
        <div className="flex flex-col gap-3">
          <h3 className="font-mono text-xs uppercase tracking-widest text-muted-foreground">
            On This Page
          </h3>
          <ul className="flex flex-col gap-1">
            {indexItems.map((item, i) => {
            const isActive = activeHash === item.to;
            return <li key={item.to} data-index={i}>
                  <Link to={item.to} className={`block py-1.5 text-sm transition-colors duration-200 ${isActive ? "border-l-2 border-primary pl-3 text-primary font-medium" : "border-l-2 border-transparent pl-3 text-muted-foreground hover:text-primary"}`}>
                    {item.label}
                  </Link>
                </li>;
          })}
          </ul>
        </div>

        <div className="flex flex-col gap-3">
          <h3 className="font-mono text-xs uppercase tracking-widest text-muted-foreground">
            Deep Dives
          </h3>
          <ul className="flex flex-col gap-1">
            {deepDiveItems.map((item, i) => {
            const isActive = currentPath === item.to;
            return <li key={item.to} data-index={i}>
                  <Link to={item.to} className={`block py-1.5 text-sm transition-colors duration-200 ${isActive ? "border-l-2 border-primary pl-3 text-primary font-medium" : "border-l-2 border-transparent pl-3 text-muted-foreground hover:text-primary"}`}>
                    {item.label}
                  </Link>
                </li>;
          })}
          </ul>
        </div>
      </aside>
    </>;
}